<script>
    export default {
        functional: true,
        render (createElement, { data, listeners, slots }) {
            return createElement('div', {
                class: [
                    'table-row',
                    'px-3',
                    data.staticClass
                ].join(' '),
                on: {
                    click: listeners.click ? listeners.click : () => {}
                }
            }, slots().default)
        }
    }
</script>
